import { render, staticRenderFns } from "./eventSettingComponent.vue?vue&type=template&id=50dae63c&"
import script from "./eventSettingComponent.vue?vue&type=script&lang=ts&"
export * from "./eventSettingComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports